export default {
    browserTypes: {
        "edge": "Microsoft Edge",
        "ie10": "Internet Explorer 10",
        "ie11": "Internet Explorer 11",
        "opera": "Opera",
        "firefox": "Mozilla Firefox",
        "chrome": "Google Chrome",
        "safari": "Safari"
    },

    activate: function() {
        var _this = this,
            className = _this.getClassName();

        if ( className !== '' ) {
            $( 'html' )
                .addClass( _this.getClassName() );
        }
    },

    getBrowser: function () {
        var _this = this,
            userAgent = navigator.userAgent.toLowerCase();

        if ( /edge/i.test( userAgent ) ) {
            return _this.browserTypes.edge;
        } else if ( /rv:11/i.test( userAgent ) ) {
            return _this.browserTypes.ie11;
        } else if ( /msie 10/i.test( userAgent ) ) {
            return _this.browserTypes.ie10;
        } else if ( /opr/i.test( userAgent ) ) {
            return _this.browserTypes.opera;
        } else if ( /chrome/i.test( userAgent ) ) {
            return _this.browserTypes.chrome;
        } else if ( /firefox/i.test( userAgent ) ) {
            return _this.browserTypes.firefox;
        } else if ( !!navigator.userAgent.match( /Version\/[\d\.]+.*Safari/ ) ) {
            return _this.browserTypes.safari;
        }

        return undefined;
    },

    getClassName: function () {
        var _this = this,
            browser = _this.getBrowser(),
            browserType = '';

        switch ( browser ) {
            case _this.browserTypes[ "edge" ]:
                browserType = _this.browserTypes[ "edge" ];
                break;
            case _this.browserTypes[ "ie11" ]:
                browserType = _this.browserTypes[ "ie11" ];
                break;
            case _this.browserTypes[ "ie10" ]:
                browserType = _this.browserTypes[ "ie10" ];
                break;
            case _this.browserTypes[ "opera" ]:
                browserType = _this.browserTypes[ "opera" ];
                break;
            case _this.browserTypes[ "chrome" ]:
                browserType = _this.browserTypes[ "chrome" ];
                break;
            case _this.browserTypes[ "firefox" ]:
                browserType = _this.browserTypes[ "firefox" ];
                break;
            case _this.browserTypes[ "safari" ]:
                browserType = _this.browserTypes[ "safari" ];
                break;
        }

        return browserType;
    }
};
